import React from 'react';
import { Alert, Button } from '@/shared/components';

interface Props {
    mode: 'create' | 'edit';
    optionsError: string | null;
    error?: string | null;
    isLoading: boolean;
    busy: boolean;
    submitDisabled?: boolean;
    onSecondaryAction: () => void;
    onCancel: () => void;
}

export const PlanVehicleRuleFormActions: React.FC<Props> = ({
    mode,
    optionsError,
    error,
    isLoading,
    busy,
    submitDisabled = false,
    onSecondaryAction,
    onCancel,
}) => (
    <>
        {optionsError && (
            <Alert variant="error">
                <span>{optionsError}</span>
            </Alert>
        )}

        {error && (
            <Alert variant="error">
                <span>{error}</span>
            </Alert>
        )}

        <div className="flex gap-2">
            <Button size="sm" disabled={busy || submitDisabled}>
                {isLoading
                    ? (mode === 'edit' ? 'Saving...' : 'Adding...')
                    : (mode === 'edit' ? 'Save Changes' : 'Add Rule')}
            </Button>
            <Button
                size="sm"
                variant="outline"
                type="button"
                onClick={onSecondaryAction}
                disabled={busy}
            >
                {mode === 'edit' ? 'Reset' : 'Clear'}
            </Button>
            <Button size="sm" variant="outline" type="button" onClick={onCancel} disabled={busy}>
                Cancel
            </Button>
        </div>
    </>
);
